module.exports = __webpack_public_path__ + "img/officePic2s.6cc59ee6.jpg";